export enum TicketListQueryType {
  AllTicket = "ALL_TICKET",
  MyTicket = "MY_TICKET",
}

export enum TicketFilterOptions {
  ShowAllTicket = 'SHOW_ALL_TICKET',
  ActiveTickets = 'ONLY_OPEN',
  SolvedAndClosed = 'SOLVED_AND_CLOSED',
  CustomFilter = "CUSTOM_FILTER"
}

